import { NavLink } from 'react-router-dom'
import Dropdown from 'components/Dropdown'
import linksJson from 'data/links.json'
import styles from './Navigation.module.scss'

const navLinks = [
  { props: { to: '/track' }, children: 'Трекинг' }
]

const links = [
  {
    props: {
      href: linksJson.manager,
      target: '_blank',
      rel: 'noreferrer'
    },
    children: 'Помощь'
  },
  {
    props: {
      href: 'https://fasales.ru',
      target: '_blank',
      rel: 'noreferrer'
    },
    children: 'О нас'
  }
]

const NavLinks = navLinks.map((link, index) => {
  return (
    <NavLink
      key={ index }
      style={
        ({ isActive }) => isActive ? { backgroundColor: '#eceef0' } : undefined
      }
      { ...link.props }>{ link.children }</NavLink>
  )
})

const Links = links.map((link, index) => {
  return (
    <a key={ index } { ...link.props }>{ link.children }</a>
  )
})

export default function Navigation () {
  return (
    <nav className={ styles.container }>
      <Dropdown groups={ [NavLinks, Links] } />
    </nav>
  )
}
